import { useContext, useEffect, useState } from 'react';
import { BrowserHistoryContext } from '../../global/BrowserHistoryContext/BrowserHistoryContext.tsx';

type GalleryBrowserHistoryState = {
    galleryModalOpen?: boolean;
};

type GalleryModalState = {
    isGridOpen: boolean;
    isZoomOpen: boolean;
    canMountGalleryModal: boolean;
    selectedIndex: number;
    setSelectedIndex: (index: number) => void;
    openGrid: (startingIndex?: number) => void;
    closeGrid: () => void;
    openZoom: (index: number) => void;
    closeZoom: () => void;
};

export const usePdpSharedImageGalleryModalState = (): GalleryModalState => {
    const { currentState, pushState, back } = useContext(BrowserHistoryContext);
    const [isGridOpen, setIsGridOpen] = useState(false);
    const [isZoomOpen, setIsZoomOpen] = useState(false);
    const [selectedIndex, setSelectedIndex] = useState(0);
    const [canMountGalleryModal, setCanMountGalleryModal] = useState(false);

    useEffect(() => {
        setCanMountGalleryModal(true);
    }, []);

    useEffect(() => {
        const galleryModalOpen = !!(currentState as GalleryBrowserHistoryState).galleryModalOpen;
        if (galleryModalOpen !== isGridOpen) {
            setIsGridOpen(galleryModalOpen);
            if (!galleryModalOpen) {
                setIsZoomOpen(false);
            }
        }
    }, [currentState, isGridOpen]);

    const openGrid = (startingIndex?: number): void => {
        if (startingIndex !== undefined) {
            setSelectedIndex(startingIndex);
        }
        pushState({ galleryModalOpen: true }, '#galleryModalOpen');
        setIsGridOpen(true);
    };

    const closeGrid = (): void => {
        setIsZoomOpen(false);
        if (isGridOpen) {
            back();
        }
        setIsGridOpen(false);
    };

    const openZoom = (index: number): void => {
        setSelectedIndex(index);
        setIsZoomOpen(true);
    };

    const closeZoom = (): void => {
        setIsZoomOpen(false);
    };

    return {
        isGridOpen,
        isZoomOpen,
        canMountGalleryModal,
        selectedIndex,
        setSelectedIndex,
        openGrid,
        closeGrid,
        openZoom,
        closeZoom,
    };
};
